import React, { useState, useEffect } from 'react';
import { Table, DatePicker, Select, Button, Space, message } from 'antd';
import { customBaseUrl, httpGet } from '../../../store/http';
import { hideLoader, showLoader } from '../../../utils/loader';
import Swal from 'sweetalert2';

const { RangePicker } = DatePicker;
const { Option } = Select;

const ProductReports = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedProductCode, setSelectedProductCode] = useState(null);
  const [dateRange, setDateRange] = useState([]);

  const fetchProducts = async () => {
    try {
      const response = await httpGet(`${customBaseUrl.integUrl}/api/v1/products?page=0&size=1000`); // Fetch all products
      if (response.status) {
        setProducts(response.data.content);
      } else {
        Swal.fire('Error', response.message || 'Failed to fetch products', 'error');
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      Swal.fire('Error', 'An error occurred while fetching products', 'error');
    }
  };

  const fetchReports = async () => {
    if (!selectedProductCode || dateRange.length !== 2) {
      message.warning('Please select a product and a date range.');
      return;
    }

    setLoading(true);
    showLoader();
    try {
      const fromDate = dateRange[0].format('YYYY-MM-DD');
      const toDate = dateRange[1].format('YYYY-MM-DD');
      const response = await httpGet(`${customBaseUrl.integUrl}/api/v1/pricing/reports/${selectedProductCode}?fromDate=${fromDate}&toDate=${toDate}`);
      if (response.status) {
        setReports(response.data); // Assuming response.data is an array of report items
      } else {
        Swal.fire('Error', response.message || 'Failed to fetch reports', 'error');
      }
    } catch (error) {
      console.error('Error fetching reports:', error);
      Swal.fire('Error', 'An error occurred while fetching reports', 'error');
    } finally {
      hideLoader();
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const columns = [
    {
      title: 'Report Field 1', // Replace with actual report fields
      dataIndex: 'field1',
      key: 'field1',
    },
    {
      title: 'Report Field 2', // Replace with actual report fields
      dataIndex: 'field2',
      key: 'field2',
    },
    // Add more columns as per the actual report structure
  ];

  return (
    <div>
      <Space style={{ marginBottom: 16 }}>
        <Select
          placeholder="Select Product"
          style={{ width: 200 }}
          onChange={(value) => setSelectedProductCode(value)}
        >
          {products.map(product => (
            <Option key={product.productCode} value={product.productCode}>
              {product.productName}
            </Option>
          ))}
        </Select>
        <RangePicker onChange={(dates) => setDateRange(dates)} />
        <Button type="primary" onClick={fetchReports}>
          Generate Report
        </Button>
      </Space>
      <Table
        columns={columns}
        dataSource={reports}
        rowKey={(record, index) => index} // Assuming no unique key in report data
        loading={loading}
        pagination={false} // Reports might not need pagination
      />
    </div>
  );
};

export default ProductReports;
